import React from 'react';
import AppLoader from '../../../common/AppLoader';
import PatientMilestones from '../../../PatientMilestones';
import { IMilestoneData, UIMilestone } from '../../../../api/getMilestone';

const PPMilestones: React.FC<{
    milestoneData: UIMilestone;
    isMilestoneDataLoading: boolean;
    updateMilestones: (onSuccess?: (() => void) | undefined) => Promise<UIMilestone>;
}> = ({ milestoneData, isMilestoneDataLoading, updateMilestones }) => {
    return isMilestoneDataLoading ? (
        <div className="w-full h-full flex justify-center items-center">
            <AppLoader />
        </div>
    ) : (
        <PatientMilestones
            milestoneData={milestoneData}
            key={Object.keys(milestoneData).length}
            updateMilestoneData={updateMilestones}
        />
    );
};

export default PPMilestones;
